import window from 'window-or-global';

export const AJS_MAJOR_VERSION = parseInt(window.AJS.version.charAt(0));
